import { TaskItemDto } from '@/api/generated';
import { TasksListTableRow } from '@/views/tasks/list/components/table/components/TasksListTableRow.comp.tsx';

type Props = {
  row: TaskItemDto;
};

export const ProcessDetailsTasksTableRow = ({ row }: Props) => {
  return <TasksListTableRow row={row} />;
};
